import queryString from 'query-string';

type XhrBody =
  | string
  | FormData
  | Blob
  | ArrayBufferView
  | ArrayBuffer
  | URLSearchParams
  | ReadableStream
  | Document
  | undefined;

type HttpBody = { [key: string]: any } | XhrBody;

interface FetchParams {
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  responseType: 'arraybuffer' | 'blob' | 'document' | 'json' | 'text';
  headers: { [key: string]: string };
  query: { [key: string]: string };
  body: HttpBody;
}

function isRequestOk({ status }: XMLHttpRequest) {
  return status >= 200 && status <= 299;
}

function formatBody(body?: HttpBody): XhrBody {
  if (body && body.toString() === '[object Object]') {
    // handle case { [key: string]: any } which is not supported by xhr.send
    return JSON.stringify(body);
  }
  return body as XhrBody;
}

function setHeaders(headers: { [key: string]: string } | undefined, xhr: XMLHttpRequest) {
  if (headers) {
    Object.keys(headers).forEach(key => xhr.setRequestHeader(key, headers[key]));
  }
}

function fetch<T>(
  url: string,
  { method = 'GET', headers, query, body, responseType = 'json' }: Partial<FetchParams>
): Promise<T> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.responseType = responseType;
    const urlToCall = query ? `${url}?${queryString.stringify(query)}` : url;

    xhr.onload = () => {
      if (isRequestOk(xhr)) {
        resolve(xhr.response);
      } else {
        reject(xhr.response);
      }
    };

    xhr.onerror = () => {
      reject(xhr.statusText);
    };

    xhr.open(method, urlToCall);
    setHeaders(headers, xhr);

    // @ts-ignore
    xhr.send(formatBody(body));
  });
}

export { fetch };
export type { FetchParams };
